import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function ElevenElite() {
  return (
    <>
      <Navbar2 />
      <div className='container-fluid px-0 pb-4 pt-5'>
        <div className="row">
            <div className="col">
              <div className='h1 text-center'>11 Elite
                <br />2025-2026 Club Roster
              </div>
            </div>
          </div>
      </div>
      <div className="container-fluid text-center">
         <div class="row justify-content-center">
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Kaitlyn Altamarino</h5>
                <p className="card-text">Head Coach</p>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div className="card mb-3">
              <div className="card-body">
                <h5 className="card-title">Patricia Altamarino</h5>
                <p className="card-text">Assistant Coach</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row text-center">
          <div className="col p-5 text-center">
            <table class="table table-striped table-bordered">
              <thead class="table-dark">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Primary Position</th>
                  <th scope="col">Jersey #</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Olivia Franklin</td>
                  <td>OH</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>Alexandria Craft</td>
                  <td>S</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>Zariah Montgomery</td>
                  <td>DS</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>Anaya Johnson</td>
                  <td>MB</td>
                  <td>7</td>
                </tr>
                <tr>
                  <td>Audrey Delgado</td>
                  <td>L</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>Addison Martinez</td>
                  <td>DS</td>
                  <td>11</td>
                </tr>
                <tr>
                  <td>Adalina Waters</td>
                  <td>OH</td>
                  <td>14</td>
                </tr>
                <tr>
                  <td>Jaye Martinez</td>
                  <td>MB</td>
                  <td>16</td>
                </tr>
                <tr>
                  <td>Makayla Perez</td>
                  <td>OPP</td>
                  <td>17</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <Footer />
      </>
  );
}

export default ElevenElite;
